export default __webpack_public_path__ + "static/media/blog-img90.ad53eff8.jpg";